import type React from 'react';

import { PageBanner } from '../components/PageBanner';
import { PageBody } from '../components/PageBody';
import { PageHeading } from '../components/PageHeading';

import { useTrackPageView } from './hooks/useTrackPageView';

export const Layout: React.FC = () => {
	useTrackPageView();

	return (
		<>
			<PageBanner />

			<div className="mx-auto w-full max-w-[1216px] px-4 pt-10 pb-20 md:px-8 xl:px-4">
				<div className="flex w-full max-w-[960px] flex-col gap-8">
					<PageHeading />

					<PageBody />
				</div>
			</div>
		</>
	);
};
